"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadUserProfilePicture = uploadUserProfilePicture;
exports.watchUploadUserProfilePicture = watchUploadUserProfilePicture;
exports["default"] = exports.userCoreSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actions = _interopRequireDefault(require("./actions"));

var _utils = require("../../../utils");

var _marked = _regenerator["default"].mark(uploadUserProfilePicture),
    _marked2 = _regenerator["default"].mark(watchUploadUserProfilePicture);

function uploadUserProfilePicture(api, action) {
  var _action$payload, userId, clientId, formData;

  return _regenerator["default"].wrap(function uploadUserProfilePicture$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, userId = _action$payload.userId, clientId = _action$payload.clientId, formData = _action$payload.formData;
          _context.prev = 1;
          _context.next = 4;
          return api.uploadProfilePicture({
            userId: userId,
            clientId: clientId,
            formData: formData
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context.next = 6;
          return (0, _effects.put)(_actions["default"].uploadProfilePictureSuccess());

        case 6:
          _context.next = 12;
          break;

        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          _context.next = 12;
          return (0, _effects.put)(_actions["default"].uploadProfilePictureError(_context.t0));

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 8]]);
}

function watchUploadUserProfilePicture(api) {
  return _regenerator["default"].wrap(function watchUploadUserProfilePicture$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].uploadProfilePicture), uploadUserProfilePicture, api);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var userCoreSagas = function userCoreSagas(api) {
  return [(0, _effects.fork)(watchUploadUserProfilePicture, api)];
};

exports.userCoreSagas = userCoreSagas;
var _default = userCoreSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map